import React from "react";
import { Navigate } from "react-router-dom";
import { useKeycloak } from "./KeycloakContext";
import { customLoader } from "../theme/loader";

const ProtectedRoute = ({ children, guest }) => {
  const { authenticated, initialized } = useKeycloak();

  if (!initialized) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        {customLoader}
      </div>
    );
  }

  if (guest) {
    return authenticated ? <Navigate to="/search" replace /> : children;
  }

  if (!authenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
